
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-border py-8 mt-auto bg-background/50 backdrop-blur-sm">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Column 1: Brand */}
            <div className="md:col-span-1">
                <h3 className="font-bold text-lg mb-2">CONSENSUS BIG BOARDS</h3>
                <p className="text-sm text-muted-foreground mb-4">
                    Rank anything. Find the consensus. Join the community debate on movies, games, sports, and more.
                </p>
                <div className="text-xs text-muted-foreground space-y-1 opacity-75">
                    <p>This product uses the TMDB API but is not endorsed or certified by TMDB.</p>
                    <p>Data provided by Google Books API.</p>
                    <p>Game data provided by IGDB.</p>
                </div>
            </div>

            {/* Column 2: Resources (New) */}
            <div>
                <h3 className="font-bold text-sm uppercase mb-3">Resources</h3>
                <ul className="space-y-2 text-sm text-muted-foreground list-none pl-0">
                    <li><Link to="/how-it-works" className="hover:text-primary transition-colors">How It Works</Link></li>
                    <li><Link to="/methodology" className="hover:text-primary transition-colors">Methodology</Link></li>
                    <li><Link to="/wisdom-of-crowds" className="hover:text-primary transition-colors">Wisdom of Crowds</Link></li>
                    <li><Link to="/data-integrity" className="hover:text-primary transition-colors">Data Integrity</Link></li>
                    <li><Link to="/ranking-tips" className="hover:text-primary transition-colors">Ranking Tips</Link></li>
                    <li><Link to="/community-guidelines" className="hover:text-primary transition-colors">Community Guidelines</Link></li>
                </ul>
            </div>

            {/* Column 3: Links */}
            <div>
                <h3 className="font-bold text-sm uppercase mb-3">Company</h3>
                <ul className="space-y-2 text-sm text-muted-foreground list-none pl-0">
                    <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
                    <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
                    <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
                    <li><Link to="/legal" className="hover:text-primary transition-colors">Legal</Link></li>
                    <li><a href="mailto:feedback.consensusbigboards@gmail.com" className="hover:text-primary transition-colors">Contact Us</a></li>
                </ul>
            </div>

            {/* Column 4: Legal */}
            <div>
                <h3 className="font-bold text-sm uppercase mb-3">Legal & Disclosure</h3>
                <p className="text-xs text-muted-foreground mb-2">
                    As an Amazon Associate I earn from qualifying purchases.
                </p>
                <p className="text-xs text-muted-foreground mb-2">
                    &copy; {new Date().getFullYear()} Consensus Big Boards. All rights reserved.
                </p>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
